import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { first } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { AuthenticationService } from '../service/authentication.service';
import { SeoService } from '../service/seo.service';
import { GlobalComponent } from '../global/global.component';

@Component({
  selector: 'login-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.scss']
})
export class ContactusComponent implements OnInit {

  name: string = '';
  email: string = '';
  phone: string = '';
  message: string = '';

  // New fields
  leadType: string = '';
  captchaToken: string = '';

  subject: string = '';

  hostName = GlobalComponent.hostName;

  constructor(
    public toastr: ToastrManager,
    private router: Router,
    private authenticationService: AuthenticationService,
    private SEOService: SeoService
  ) {}

  ngOnInit(): void {

    this.SEOService.updateCanonicalUrl(
      this.hostName + '/contactus'
    );

    window.scrollTo(0, 0);
  }

  // reCAPTCHA callback

  resolved(token: string): void {
    this.captchaToken = token;
  }

  sendmessage(): void {

    if (
      !this.name ||
      !this.email ||
      !this.phone ||
      !this.message
    ) {
      this.toastr.errorToastr(
        'Please fill all required fields.'
      );
      return;
    }

    // Validate Email

    const emailPattern =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailPattern.test(this.email)) {
      this.toastr.errorToastr(
        'Please enter a valid email address.'
      );
      return;
    }

    // Validate Mobile

    if (this.phone.length < 10) {
      this.toastr.errorToastr(
        'Please enter a valid phone number.'
      );
      return;
    }

    // reCAPTCHA validation

    if (!this.captchaToken) {
      this.toastr.errorToastr(
        'Please verify that you are not a robot.'
      );
      return;
    }

    // Auto Subject

    this.subject =
      this.leadType && this.leadType !== ''
        ? `[${this.leadType}] Contact Request`
        : 'Website Contact Request';

    this.authenticationService
      .sendmessage(
        this.name,
        this.email,
        this.subject,
        this.message,
        this.phone
      )
      .pipe(first())
      .subscribe(
        data => {

          Swal.fire(
            'Thank You!',
            'Our team will contact you shortly.',
            'success'
          );

          // Reset Form

          this.name = '';
          this.email = '';
          this.phone = '';
          this.message = '';
          this.leadType = '';
          this.subject = '';
          this.captchaToken = '';

        },
        error => {

          this.toastr.errorToastr(
            'Something went wrong. Please try again.'
          );

        }
      );
  }

  signup(): void {

    this.router.navigate([
      '/login/signup'
    ]);

  }

}